import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./styles/global.css";
import { App } from "./App";
import { startSyncScheduler } from "./lib/sync-manager";
import { installErrorReporter } from "./lib/error-reporter";

// Démarre la sync queue (online listener + tentative initiale 1s post-boot).
startSyncScheduler();
// Monitoring maison : capture window.onerror + unhandledrejection.
installErrorReporter();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("Root #root not found in index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
